import axios from "axios";
import { host } from "../../configuraciones";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//constantes
const dataInicial = {
  data: {
    dataRegistro: [],
    dataExtraccion: [],
    dataGuiaUnica: [],
    dataGuiaIdDatosPredio: [],
  },
  tipo: 0,
};
//types
const OBTENER_CONSTANCIAS_EXITO = "OBTENER_CONSTANCIAS_EXITO";
const AGREGAR_CONSTANCIAS_EXITO = "AGREGAR_CONSTANCIAS_EXITO";

const ACTUALIZAR_CONSTANCIAS_EXITO = "ACTUALIZAR_CONSTANCIAS_EXITO";

const OBTENER_CONSTANCIAS_EXTRACCION_EXITO = "OBTENER_CONSTANCIAS_EXTRACCION_EXITO";
const OBTENER_CONSTANCIAS_REGISTRO_EXITO = "OBTENER_CONSTANCIAS_REGISTRO_EXITO";
const OBTENER_CONSTANCIAS_NUEVA_GUIA_UNICA_EXITO ="OBTENER_CONSTANCIAS_NUEVA_GUIA_UNICA_EXITO";

const OBTENER_CONSTANCIAS_NUEVA_GUIA_EXITO ="OBTENER_CONSTANCIAS_NUEVA_GUIA_EXITO";
const OBTENER_GUIAS_UNICA_EXITO = 'OBTENER_GUIAS_UNICA_EXITO'

export const obtenerTodasConstancias = createAsyncThunk(
  OBTENER_CONSTANCIAS_EXITO,
  async () => {
    try {
      const fullUrl = host + `Constancia/obtenerAllConstancia`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerTodasConstanciasRegistro = createAsyncThunk(
  OBTENER_CONSTANCIAS_REGISTRO_EXITO,
  async () => {
    try {
      const fullUrl = host + `Constancia/obtenerAllConstanciaByTipo/Registro`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerTodasConstanciasExtraccion = createAsyncThunk(
  OBTENER_CONSTANCIAS_EXTRACCION_EXITO,
  async () => {
    try {
      const fullUrl = host + `Constancia/obtenerAllConstanciaByTipo/Extraccion`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerTodasConstanciasGuiasUnicas = createAsyncThunk(
  OBTENER_CONSTANCIAS_NUEVA_GUIA_EXITO,
  async () => {
    try {
      const fullUrl = host + `Constancia/obtenerAllConstanciaByTipoGuia/NuevaGuia`;
      const res = await axios.get(fullUrl);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const obtenerTodasConstanciasGuiaByIdDatosPredio = createAsyncThunk(
  OBTENER_CONSTANCIAS_NUEVA_GUIA_UNICA_EXITO,
  
  async (data) => {
    try {
      const fullUrl = host + `Constancia/obtenerAllConstanciaGuiaByIdDatosPredio/=${data.iddatospredio}&=${data.tipoconstancia}`;
      const result = await axios.get(fullUrl, data);
      var arrayOrdenados = sortJSON(result.data.data, 'idconstancia', 'asc');
      return arrayOrdenados
    } catch (error) {
      console.log(error);
    }
  }
);

export const agregarNuevaConstancia = createAsyncThunk(
  AGREGAR_CONSTANCIAS_EXITO,
  async (data) => {
    try {
      const fullUrl = host + `Constancia/agregarConstancia`;
      const result = await axios.post(fullUrl, data);
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
function sortJSON(data, key, orden) {
  return data.sort(function (a, b) {
      var x = a[key],
      y = b[key];

      if (orden === 'asc') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }

      if (orden === 'desc') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
  });
}
export const actualizarConstancia = createAsyncThunk(
  ACTUALIZAR_CONSTANCIAS_EXITO,
  async (data) => {
    try {
      const fullUrl = host + `Constancia/actualizarConstancia`;
      const result = await axios.put(fullUrl, data);
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
export const obtenerGuiaByIdDatosPredio = createAsyncThunk(
  OBTENER_GUIAS_UNICA_EXITO,
  async (data) => {
    try {
      const fullUrl = host + `Guias/obtenerGuiaByIdPredio/${data.iddatospredio}`;
      const result = await axios.get(fullUrl, data);
      return result.data.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const constanciasSlice = createSlice({
  name: "constanciasSlice",
  initialState: dataInicial,
  reducers: {
    cambiarEstado(state, { payload }) {
      state.tipo = payload;
    },

    setInitialDataGuia(state, {payload}){
     state.data.dataGuiaIdDatosPredio = []
      }
  },
  extraReducers: {
    [obtenerTodasConstancias.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },
    [obtenerTodasConstanciasRegistro.fulfilled]: (state, { payload }) => {
      state.data.dataRegistro = payload.data;
    },
    [obtenerTodasConstanciasExtraccion.fulfilled]: (state, { payload }) => {
      state.data.dataExtraccion = payload.data;
    },
    [obtenerTodasConstanciasGuiasUnicas.fulfilled]: (state, { payload }) => {
      state.data.dataGuiaUnica = payload.data;
    },
    [agregarNuevaConstancia.fulfilled]: (state, { payload }) => {},

    [actualizarConstancia.fulfilled]: (state, { payload }) => {},

    [obtenerTodasConstanciasGuiaByIdDatosPredio.fulfilled]: (state, { payload }) => {
      state.data.dataGuiaIdDatosPredio = payload.data;
    }
    
  },
});

export const { cambiarEstado,setInitialDataGuia } = constanciasSlice.actions;
export const ConstanciasReducerUsuarioAgricola = constanciasSlice.reducer;
